export async function initDeviceId() {
  const DeviceSdk = window.DeviceSdk;
  if (DeviceSdk === undefined) {
    return Promise.reject();
  }
  const deviceSdk = new DeviceSdk({
    token: `${process.env.REACT_APP_DEVICE_MANAGEMENT_TOKEN}`,
    baseUrl: `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}`,
  });
  const deviceId = await deviceSdk.getDeviceId();
  if (window.dtrum && typeof window.dtrum.identifyUser === 'function') {
    try {
      window.dtrum.identifyUser(deviceId);
    } catch (e) {
      // Fail silently, do not break user experience
      // eslint-disable-next-line no-console
      console.error('dtrum.identifyUser failed:', e);
    }
  }
  return deviceId;
}

export function initProfiling() {
  const DeviceSdk = window.DeviceSdk;
  if (DeviceSdk === undefined) {
    return Promise.reject();
  }
  const deviceSdk = new DeviceSdk({
    token: `${process.env.REACT_APP_DEVICE_MANAGEMENT_TOKEN}`,
    baseUrl: `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}`,
  });
  return deviceSdk.collectProfiling();
}
